// 标签转换
let labelArr = [{ id: 1, text: "特卖" },
{ id: 2, text: "优惠" },
{ id: 3, text: "效期" },
{ id: 4, text: "买赠", img: "https://image.hezongyy.com/pcimage/shopCar/shopcar_activemz.png" },
{ id: 5, text: "阶梯" },
{ id: 6, text: "精品" },
{ id: 7, text: "控销" },
{ id: 8, text: "加盟", img: "https://image.hezongyy.com/pcimage/shopCar/shopcar_activejm3.png" },
{ id: 9, text: "VIP商品" },
{ id: 10, text: "特价" },
{ id: 11, text: "秒杀", img: "https://image.hezongyy.com/pcimage/shopCar/shopcar_activems.png" },
{ id: 12, text: "直播", img: "https://image.hezongyy.com/pcimage/shopCar/shopcar_activezb.png" },
{ id: 13, text: "随机特价" },
{ id: 14, text: "拼团" },
{ id: 15, text: "业务买赠" },
{ id: 16, text: "爆品" },
{ id: 17, text: "换购", img: "https://image.hezongyy.com/pcimage/shopCar/shopcar_activehg.png" },
{ id: 18, text: "组合购" },
{ id: 19, text: "促销", img: "https://image.hezongyy.com/pcimage/shopCar/shopcar_activecx.png" },
{ id: 20, text: "商品不可使用优惠券" },
{ id: 21, text: "集采", img: "https://image.hezongyy.com/pcimage/shopCar/shopcar_activejc3.png" },
    // { id: 22, text: "商品新人特价"},
]
export default {
    getLabel(obj, _that) {
        _that.$set(obj, "newLabel", []);
        if (obj.label) {
            _that.$set(obj, 'goodsLabels', obj.label)
        }
        if (obj.goodsLabels.length != 0) {
            for (let i = 0; i < obj.goodsLabels.length; i++) {
                // 判断是否买赠换购  isSwap==17：换购；isSwap==4：买赠
                if (obj.goodsLabels[i].type == 17 || obj.goodsLabels[i] == 17) {
                    _that.$set(obj, 'isSwap', 17)
                }
                if (obj.goodsLabels[i].type == 4 || obj.goodsLabels[i] == 4) {
                    _that.$set(obj, 'isSwap', 4)
                }
                for (let k = 0; k < labelArr.length; k++) {
                    // 此处注释是因为罗庆阳产品又要显示加盟标签2021-8-25
                    // if (obj.goodsLabels[i].type != 8 && obj.goodsLabels[i] != 8) {// 罗庆阳产品说加盟标签不显示，此次多加判断方便买赠换购下标 2021-07-26
                    if (obj.goodsLabels[i].type == labelArr[k].id || obj.goodsLabels[i] == labelArr[k].id) {
                        // 生成页面渲染的新数组
                        obj.newLabel.push({ text: labelArr[k].text, img: labelArr[k].img, id: labelArr[k].id });
                    }
                    // 可用于判断效期
                    if (obj.goodsLabels[i] == 3 || obj.goodsLabels[i].type == 3) {
                        _that.$set(obj, "dateEndFlag", true);
                    }
                    // }
                }
            }
        }
    },
}



// WEBPACK FOOTER //
// ./src/config/getLabel.js